import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './AvailabilityMessage.styles'

const AvailabilityMessageText = ({ message }) => <span dangerouslySetInnerHTML={{ __html: message }} />

const AvailabilityMessage = ({
  icon,
  hideIcon,
  message,

  'data-test': dataTest
}) => {
  return (
    <>
      <Styled.Container icon={icon} hideIcon={hideIcon} data-test={dataTest}>
        <AvailabilityMessageText message={message} />
      </Styled.Container>
    </>
  )
}
AvailabilityMessage.propTypes = {
  message: PropTypes.string,
  icon: PropTypes.string,
  hideIcon: PropTypes.bool,
  'data-test': PropTypes.string
}

AvailabilityMessage.defaultProps = {
  'data-test': 'availability-message'
}

export default AvailabilityMessage
